import {
    mapGetters,
    mapActions
} from 'vuex';
// import bModal from 'bootstrap-vue/es/components/modal/modal'

import { required, minLength } from 'vuelidate/lib/validators'
import TransitionExpand from '../../components/TransitionExpand/TransitionExpand.vue'
import EnvoiUnitaireLetRecoElec from '../../components/EnvoiUnitaireLetRecoElec/EnvoiUnitaireLetRecoElec.vue'
import TableauDestinataire from '../../components/TableauDestinataires/TableauDestinataires.vue'
import OiseauAnimation from '../../components/OiseauAnimation/OiseauAnimation.vue'
import CalculDate from '../../components/CalculDate/index.js'
import DisambiguationModal from '../../components/DisambiguationModal/DisambiguationModal.vue';
import SearchDestinataire from '../../components/SearchDestinataire/searchDestinataire';
import UserSelect from '../../components/UserSelect/UserSelect.vue';
import FileDrop from '../../components/FileDrop/FileDrop.vue'

export default {
    components: {
        TransitionExpand,
        EnvoiUnitaireLetRecoElec,
        TableauDestinataire,
        OiseauAnimation,
        DisambiguationModal,
        UserSelect,
        FileDrop
    },
    data() {
        return {
            destinataires: [],
            fileObjectTab: [],
            emetteur: {},
            produitSelect: "",
            loadingDestinataires: false,
            fileTabLength: 0,
            currentPage: 1,
            commentaire: "",
            dateRemise: new Date(Date.now()+24*60*60*1000).toJSON().slice(0, 10),
            dateEstimee: '',
            nomCopro: '',
            adresseCopro: '',
            dateAG: '',
            typeAG: '',
            typeAGAutres: '',
            categories: [],
            sousCatSelect: null,
            indOptionEnveloppe: 0,
            groupIdSelect: [],
            categorieEnveloppe: [],
            categorieFichier: [],
            enveloppeValidee: false,
            files:[],
            filesWaiting: [],
            filesToSort: [],
            dragging: false,
            dragover: null,
            composanteWaiting: [],
            isErrorOptionComposante: false,
            currentDrop: null,
            fileSelect: 0,
            modeEdit: false,
            problemeEnveloppe: false,
            problemeEnveloppeDetails: '',
            problemeEnveloppeOptionId: 0,
            numero: '',
            reference: true,
            submitted: false,
            timeout: -1,
        }
    },

    computed: {
        ...mapGetters([
            'categorie', 'fileUploading', 'lastOrder', 'auth', 'percentUploaded'
        ]),

        filesNoTri() {
            return this.files.filter(f => f.isWaitingNode === false)
        },

        isSousCategorieSansDestinataire() {
            return (
                this.files.find((f) => f.title === "Destinataires") == undefined
            );
        },

        myCategories() {
            if(this.auth && this.auth.user && this.auth.user.categories && this.auth.user.categories.length > 0) {
                return this.categories.filter(cat => this.auth.user.categories.find(c => c.id === cat.id))
            }
            return this.categories
        },

        isAdmin() {
            if(this.auth && this.auth.user && this.auth.user.roles && 
                this.auth.user.roles.find((role) => role.name === "admin")) {
                return true
            }
            return false
        },

        rows() {
            return this.destinataires.length
        },

        isSuivi() {
            return this.groupAffranchissement &&
                this.groupAffranchissement.groupe &&
                this.groupAffranchissement.groupe.value &&
                !this.groupAffranchissement.groupe.value.toLowerCase().includes('recommandé') && 
                !this.groupAffranchissement.groupe.value.toLowerCase().includes('colissimo')
        },

        dateRemiseMinimum() {
            let maintenant = new Date();
            if(maintenant.getHours() < 12) {
                return new Date(Date.now()).toJSON().slice(0, 10)
            }
            return new Date(Date.now()+24*60*60*1000).toJSON().slice(0, 10)
        },

        groupAffranchissement() {
            if(this.categorieEnveloppe) {
                return this.categorieEnveloppe.find((cat) => {return cat.groupe.libelle === "Affranchissement"})
            }
            return undefined            
        },

        adresseFile() {
          if (this.files.length > 1) {
            return this.files[1].children;
          } else {
            return [];
          }
        },

        groupShow: function () {
            if (this.categorieEnveloppe && this.categorieEnveloppe.length > 0) {
                return _.without(this.categorieEnveloppe, this.groupAffranchissement);
            } else {
                return [];
            }
        },

        optionsEnveloppeText: function () {
            if (this.categorieEnveloppe && this.categorieEnveloppe.length > 0) {
                return this.categorieEnveloppe.map(function (group, index) {
                    return group.groupe.groupe_options.filter(function (option, index) {
                        return option.selected == true;
                    });
                }).filter(function (group, index) {
                    return group.length > 0;
                }).map(function (option, ind, ) {
                    return '<li>' + option.map(function (op, i) {
                        return '  ' + op.libelle
                    }) + '</li>'
                }).join('');
            } else {
                return '';
            }
        },

        optionsEnveloppe: function () {
            if (this.categorieEnveloppe && this.categorieEnveloppe.length > 0) {
                return this.categorieEnveloppe.map(function (group, index) {
                    return group.groupe.groupe_options.filter(function (option, index) {
                        return option.selected == true;
                    })
                }).filter(function (group, index) {
                    return group.length > 0;
                });
            } else {
                return [];
            }
        },

        treeView: function () {
            return {
                dataSource: this.files,
                id: 'id',
                text: 'libelle',
                child: 'files'
            }
        },

        ambiguousFile() {
            let ambiguousFile = false
            this.filesNoTri.forEach(composante => {
                if(composante.title != 'Destinataires') {
                    ambiguousFile = composante.children.find(file => file.destinataire.length > 1)
                }
            })
            return ambiguousFile
        },
    },

    methods: {

        ...mapActions([
            'getCategorie', 'uploadFiles', 'createCommande', 'getLastOrder'
        ]),

        /* TODO JOFA */
        dropFileOnDestinataire(event) {
            const file = this.filesNoTri.find(c => c.title === event.data.composante).children.find(f => f.title === event.data.title)
            this.selectDestinataire({file, dest:event.destinataire})
        },

        isProblemRemaining() {
            let existProblem = false
            if(this.categorieEnveloppe && (!this.sousCatSelect || this.sousCatSelect.choix_groupe == 1)) {
                this.categorieEnveloppe.forEach(aGroup => {
                    if (aGroup.groupe.probleme) {
                        existProblem = true
                        console.log('group pb');
                    }
                })
            }
            if(this.produitSelect && !this.files[0] || (this.files[0] && this.files[0].children.length > 0) || (this.files[1] && this.files[1].children.length == 0) || this.numero == "") {
                existProblem = true
                console.log('file pb');
            }
            return existProblem
        },

        selectionneProduit(type) {
            if(this.auth && this.auth.user && this.auth.user.entreprise && this.auth.user.entreprise.statut == 'Bloqué'){
                return;
            }
            let selectedCat = this.categories.find(cat => {return cat.code === type});
            if (!this.produitSelect && selectedCat.available) {
                this.indOptionEnveloppe = 0;
                this.produitSelect = type;
                this.getCategorie(selectedCat.id).then((response) => {
                    this.categorieEnveloppe = this.categorie.categorie_has_groupes.filter(function (group, index) {
                        return group.groupe.portee == 1
                    });
                    this.categorieFichier = this.categorie.categorie_has_groupes.filter(function (group, index) {
                        return group.groupe.portee == 2
                    });
                    if (this.categorie.sous_categories.length <= 0) {
                      this.sousCatSelect = null;
                      let waitingNode = {};
                      waitingNode.title = "Fichiers à trier";
                      waitingNode.isWaitingNode = true;
                      waitingNode.children = [];
                      waitingNode.draggable = false;
                      waitingNode.droppable = false;
                      waitingNode.noParam = true;
                      this.files.push(waitingNode);
                      this.categorie.composantes.forEach(composante => {
                        let node = {};
                        node.id = composante.id;
                        node.title = composante.libelle;
                        node.children = [];
                        node.isWaitingNode = false
                        node.draggable = false;
                        node.droppable = false;
                        node.options = [];
                        node.noParam = composante.noParam;
                        node.hint = composante.hint;
                        this.categorieFichier.forEach(categ => {
                          let options = {};
                          options = JSON.parse(JSON.stringify(categ))
                          node.options.push(options);
                        });
                      this.files.push(node);
                      this.getLastOrder({catId:this.categorie.id,sousCatId:null})
                        .then((response) => {
                            this.loadLastOrderEnveloppe()
                        }).catch(error => {
                        });
                      });
                    }
                }).catch(error => {console.log(error)});
            } else {
                if(this.myCategories.length > 1) {
                    this.cancelProduit();
                }                
            }
        },

        selectionneSousCat(SsCat) {
            if (!this.sousCatSelect) {
                this.sousCatSelect = SsCat;
                let waitingNode = {}
                this.files = []
                waitingNode.title = "Fichiers à trier"
                waitingNode.isWaitingNode = true
                waitingNode.children = []
                waitingNode.draggable = false;
                waitingNode.droppable = false;
                waitingNode.noParam = true;
                this.files.push(waitingNode);
                this.sousCatSelect.composantes.forEach(composante => {
                  let node = {};
                  node.title = composante.libelle;
                  node.id = composante.id
                    node.children = [];
                    node.isWaitingNode = false
                    node.draggable = false;
                    node.droppable = false;
                    node.options = [];
                    node.noParam = composante.noParam;
                    this.categorieFichier.forEach(categ => {
                        let options = {};
                        options = JSON.parse(JSON.stringify(categ))
                        node.options.push(options);
                    });
                  this.files.push(node);
                });
                this.getLastOrder({catId:this.categorie.id,sousCatId:this.sousCatSelect.id}).then((response) => {;
                  this.loadLastOrderEnveloppe()
                });
            } else {
                this.sousCatSelect = null;
                this.enveloppeValidee = false;
                this.existProblem = false;
                this.problemeEnveloppe = false;
            }
        },

        loadLastOrderEnveloppe() {
          if (this.lastOrder.id) {
            let groupeSelect = [];
            let optionSelect = [];
            this.lastOrder.commande_has_groupe_options.forEach(groupeOption => {
              groupeSelect = this.categorieEnveloppe.filter(groupe => {
                return groupe.groupe_id == groupeOption.groupe_option.groupe_id
              })
              if(groupeSelect[0]) {
                optionSelect = groupeSelect[0].groupe.groupe_options.filter(option => {
                  return option.id == groupeOption.groupe_option_id;
                })
                groupeSelect[0].groupe.value = optionSelect[0].libelle;
                optionSelect[0].selected = true;
                // Recalcul du délai de livraison si groupe affranchissement
                if(groupeSelect[0].groupe.libelle === "Affranchissement") {
                    let selectedGroupOptions = groupeSelect[0].groupe.groupe_options.find(element => element.libelle === groupeSelect[0].groupe.value)
                    this.dateEstimee = this.calculateDateEstimee({date_remise_en_poste: this.dateRemise}, selectedGroupOptions);
                }
              }
            });
          }
        },

        cancelProduit() {
            this.produitSelect = null;
            this.categorieEnveloppe = null;
            this.sousCatSelect = null;
            this.enveloppeValidee = false;
            this.existProblem = false;
            this.problemeEnveloppe = false;
            this.files = [];
            this.destinataires = [];
        },

        nextOptions() {
            this.indOptionEnveloppe = this.indOptionEnveloppe + 2;
            // this.$nextTick(this.recocherDejaRempli());
        },
        previousOptions() {
            this.indOptionEnveloppe = this.indOptionEnveloppe - 2;
            // this.$nextTick(this.recocherDejaRempli());
        },

        selectionneOptionRadio(option) {
            //on cherche le groupe auquel appartient l'option
            let indice = this.categorieEnveloppe.findIndex(function (groupe) {
              return groupe.groupe_id == option.groupe_id;
            });
            if (indice >= 0) {
              //on déselectionne les options et on sélectionne les autres
              this.categorieEnveloppe[indice].groupe.probleme = false
              this.categorieEnveloppe[indice].groupe.groupe_options.forEach(groupeOption => {
                groupeOption.selected = false;
                if (groupeOption.id == option.id) {
                  groupeOption.selected = true;
                  this.categorieEnveloppe[indice].groupe.value = groupeOption.libelle
                }
              });
            }
        },

        selectionneOptionRadioFile(option) {
            // //on cherche le groupe auquel appartient l'option
            let indice = this.dragover.options.findIndex(function (groupe) {
                return groupe.groupe_id == option.groupe_id;
            });
            if (indice >= 0) {
                //on déselectionne les options et on sélectionne les autres
                this.dragover.options[indice].groupe.groupe_options.forEach(groupeOption => {
                    groupeOption.selected = false;
                    if (groupeOption.id == option.id) {
                        groupeOption.selected = true;
                        this.dragover.options[indice].groupe.value = groupeOption.libelle
                    }

                });
            }
        },

        selectionneOptionSelect(id, group, event) {
            // Recalcul du délai de livraison si groupe affranchissement
            let selectedGroupOptions = group.groupe_options.find(element => element.libelle === event)
            if(group.libelle === "Affranchissement") {
                this.dateEstimee = this.calculateDateEstimee({date_remise_en_poste: this.dateRemise}, selectedGroupOptions);                
            }
            group.probleme = false
            group.groupe_options.forEach(option => {                
                if(event === option.libelle) {
                    option.selected = true;
                } else {
                    option.selected = false;
                }
            });
        },

        selectionneOptionSelectFile(id, index) {
            this.dragover.options[index].groupe.groupe_options.forEach(option => {
                option.selected = false;
            });
            this.dragover.options[index].groupe.groupe_options[this.$refs['o_' + id][0].selectedIndex].selected = true;
        },

        /**
         * Fonction popur fermer la modale de déplacement (pour mobile).
         */
        closeModalCommandeValidee() {
            this.$refs.commandeValidee.hide()
        },

        /**
         * Fonction de validation des paramètres de l'enveloppe (première étape).
         */
        validerEnveloppe() {
            console.log("validerEnveloppe")
            this.problemeEnveloppe = false;
            this.problemeEnveloppeDetails = ""
            if((this.sousCatSelect && this.sousCatSelect.choix_groupe == 0) || this.groupShow.length == 0){
                /* A DECOMMENTER QUAND IL FAUDRA VALIDER LES DESTINATAIRES 
                if (this.destinataires.length === 0) {
                    this.problemeEnveloppe = true
                    this.problemeEnveloppeDetails += "Veuillez importer des <a class='text-white' href='#destinatairesBox'>destinataires</a>. "
                    return;
                } else {*/
                    this.enveloppeValidee = true;
                    return;
                /*}*/
            }
            for (let i = 0; i < this.categorieEnveloppe.length; i++) {
                if (this.categorieEnveloppe[i].groupe.obligatoire && this.categorieEnveloppe[i].groupe.value == '') {
                    this.problemeEnveloppe = true;
                    this.categorieEnveloppe[i].groupe.probleme = true;
                    this.problemeEnveloppeDetails = "Veuillez indiquer toutes les options obligatoires. "
                } else {
                    this.categorieEnveloppe[i].groupe.probleme = false;
                }
            }
            /* A DECOMMENTER QUAND IL FAUDRA VALIDER LES DESTINATAIRES 
            if (this.destinataires.length === 0) {
                this.problemeEnveloppe = true
                this.problemeEnveloppeDetails += "Veuillez importer des destinataires. "
            } */
            if (!this.problemeEnveloppe) {
                this.enveloppeValidee = true
            }
        },

        /**
         * Fonction pour tout valider et enregistrer la commande.
         */
        validerEtEnregister() {
            this.validerEnveloppe();
            this.$v.$touch();

            if(this.problemeEnveloppe) {
                return;
            } else {
                this.problemeEnveloppeDetails = ""
                let countFiles = 0
                this.files.forEach((f) => countFiles += f.children.length)
                if(countFiles == 0) {
                    this.problemeEnveloppe = true
                    this.enveloppeValidee = false
                    this.problemeEnveloppeDetails += "Veuillez envoyer des fichiers. "
                }
                if(this.numero == "") {
                    this.problemeEnveloppe = true
                    this.enveloppeValidee = false
                    this.problemeEnveloppeDetails += "Veuillez saisir un numéro de référence commande. "
                }
                if(this.problemeEnveloppeDetails != "") {
                    return;
                }
            }

            this.submitted = true;
            if (this.$v.$invalid) {
                return;
            }
            let formData = new FormData()
            let i = 0
            this.fileObjectTab.forEach(aFile => {
                i = i + 1
                formData.append('file' + i, aFile)
            })
            this.$refs.loadingUpload.show()
            // Envoie des fichiers
            this.uploadFiles(formData).then(res => {
                // Une fois envoyé, on récupère la liste des chemins des fichiers avec leurs noms.
                const fileInfos = res.data
                fileInfos.forEach(afileInfo => {
                    // Association avec chaque fichier grâce au nom du fichier
                    this.files.forEach(aComposante => {
                        let aFile = aComposante.children.find(f => f.title === afileInfo.name && f.uploaded !== true)
                        if(aFile) {
                            aFile.path = afileInfo.path
                            aFile.uploaded = true
                        }
                    })
                })

                // Enregistrement de la commande
                const categorie = _.find(this.categories, {code: this.produitSelect});
                this.createCommande({
                  composantes: this.files,
                  destinataires: this.destinataires,
                  emetteur: this.emetteur,
                  produitSelect : categorie.id,
                  paramEnveloppe: this.categorieEnveloppe,
                  sousCatSelect: this.sousCatSelect,
                  numero: this.numero,
                  reference: this.reference,
                  commentaire: this.commentaire,
                  dateRemise: this.dateRemise,
                  dateEstimee: this.dateEstimee,
                  nomCopro: this.nomCopro,
                  adresseCopro: this.adresseCopro,
                  dateAG: this.dateAG,
                  typeAG: (this.typeAG === 'autres' && this.typeAGAutres !== '') ? this.typeAGAutres : this.typeAG,
                }).then(res => {
                    this.$refs.loadingUpload.hide()
                    this.$refs.commandeValidee.show()
                }).catch(err => {
                    this.$refs.loadingUpload.hide()
                    console.log(err)
                })

            }).catch(err => {
                this.$refs.loadingUpload.hide()
                console.log(err)
            })
        },

        onCommandeCree() {
            this.$refs.commandeValidee.show();
        },

        reload() {
          document.location.reload();
        },

        checkDateRemise() {
            if(this.dateRemise < this.dateRemiseMinimum) {
                this.dateRemise = this.dateRemiseMinimum
            }
            if(this.groupAffranchissement) {
                let selectedGroupOptions = this.groupAffranchissement.groupe.groupe_options.find(element => element.libelle === this.groupAffranchissement.groupe.value)
                if(selectedGroupOptions) {
                    this.dateEstimee = this.calculateDateEstimee({date_remise_en_poste: this.dateRemise}, selectedGroupOptions)
                }
            }
        },

        selectDestinataire({file, dest}) {
            file.destinataire.splice(0, file.destinataire.length, dest)
            // forcer vue à déclencher la réactivité en créant / supprimant une clef dans l'objet
            const dummyKey = '_u'+Date.now()
            this.$set(file, dummyKey, 'updated')
            this.$nextTick(() => {delete file[dummyKey]})
        },
    },

    validations() {
      return {
        files: {
          required,
          $each: {
            adresseLength(comp) {
              if (comp.title == 'Adresses') {
                return comp.children.length > 0
              } else {
                return true;
              }
            }
          }
        },
        numero: {
          required
        }
      }
    },

    mounted() {
        window.axios.get("/api/categories").then((response) => {
            this.categories = response.data;
            if(this.auth.user.categories.length === 1) {
                console.log("auto select")
                this.$nextTick(() => {this.selectionneProduit(this.myCategories[0].code, 0)})
            }
        });
        this.emetteur = this.auth.user;
    },

    created() {
        this.calculateDateEstimee = CalculDate.calculateDateEstimee
    },

    watch: {
        dateRemise: function(update) {
            // check si dateRemise > dateRemiseMini aprés 1.5 secondes 
            // pour laisser le temps à l'utilisateur de finir sa frappe
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => this.checkDateRemise(), 1500)
        },
        destinataires: {
            deep:true,
            handler(destinataires) {
                if(this.produitSelect === 'letreco') {
                    this.filesNoTri.forEach(composante => {
                        if(composante.title != 'Destinataires') {
                            composante.children.forEach(file => {
                                if(file.destinataire.length === 0) {
                                    SearchDestinataire.searchDestinataire(file.title, destinataires).forEach(e => file.destinataire.push(e))
                                }
                            })
                        }
                    })
                }
            }
        },
        filesNoTri: {
            deep: true,
            handler(composantes) {
                if(this.produitSelect === 'letreco') {
                    composantes.forEach(composante => {
                        if(composante.title != 'Destinataires') {
                            composante.children.forEach(file => {
                                if(!file.destinataire) {
                                    file.destinataire = []
                                }
                                if(file.destinataire.length === 0) {
                                    SearchDestinataire.searchDestinataire(file.title, this.destinataires).forEach(e => file.destinataire.push(e))
                                }
                            })
                        }
                    })
                }
            }
        }
    },
}
